import cxs from 'cxs';

import { COLOURS } from '../../../../../common/styles/vars';

export const ACTION_BTN = cxs({
  display: 'flex',
  alignItems: 'center',
  border: 'none',
  minHeight: '45px',
  width: '200px',
  padding: '10px 20px',
  boxSizing: 'border-box',
  position: 'relative',

  ':hover:after': {
    content: '""',
    background: COLOURS.cyan.jungleGreen.monkeyLight,
    position: 'absolute',
    left: '10px',
    top: '5px',
    width: 'calc(100% - 20px)',
    minHeight: 'calc(100% - 10px)',
    zIndex: -1,
    borderRadius: '8px'
  }
});

export const RED_COLOR = cxs({
  color: `${COLOURS.red.redApple} !important`
});